angular.module('IndicatorType', ['dndLists', 'ui.bootstrap', 'IndicatorTree']);
